var render = function render(){var _vm=this,_c=_vm._self._c;return _c('search-widget',{attrs:{"title":"Ask CY","titleEnd":"or Search Records","placeholder":"How do I..., Mary McTesterson, Record Name","searchAction":_vm.showCommandsDialog}})
}
var staticRenderFns = []

export { render, staticRenderFns }